import React from 'react';
import { AiOutlinePhone } from 'react-icons/ai';
import { FiFacebook, FiGithub, FiInstagram, FiLinkedin, FiTwitter } from 'react-icons/fi';
import './RightIcon.css'

const RightIcon = () => {
    return (
        <div className='max-w-[1400px] mx-auto hidden md:block ' >
            <ul className='ul-style text-xl' data-aos="fade-up" >
                <li className='mb-5 transition-style'> <a href="https://github.com/Syeda-Aisha-Ahmad" target="_blank" rel="noreferrer"> <FiGithub /> </a> </li>
                <li className='mb-5 transition-style'> <a href="https://www.linkedin.com/in/aisha-ahmad19/" target="_blank" rel="noreferrer"> <FiLinkedin /> </a> </li>
                {/* <li className='mb-5 transition-style'> <a href=""> <FiTwitter /> </a> </li> */}


                <li className='mb-5 transition-style text-2xl'> <a href="tel:123-456-7890"><AiOutlinePhone /></a> </li>
                <li className='mb-5 transition-style'> <a href="https://www.instagram.com/18aishaahmad/" target="_blank" rel="noreferrer"> <FiInstagram /> </a> </li>
                <li className='mb-5 transition-style'> <a href="https://www.facebook.com/profile.php?id=100015597035398" target="_blank" rel="noreferrer"> <FiFacebook /> </a> </li>
            </ul>
        </div>
    );
};

export default RightIcon;